import { render, staticRenderFns } from "./attachment-details-panel.vue?vue&type=template&id=43bc0672&scoped=true&"
import script from "./attachment-details-panel.vue?vue&type=script&lang=js&"
export * from "./attachment-details-panel.vue?vue&type=script&lang=js&"
import style0 from "./attachment-details-panel.vue?vue&type=style&index=0&id=43bc0672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bc0672",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
